import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import App from './App.tsx';
import './index.css';

// The PWA's service worker is registered with registerType: 'autoUpdate'
// (skipWaiting + clientsClaim baked into the generated sw.js), so a new
// deploy takes control of *already-open* tabs mid-session with no reload.
// The injected registration script (vite-plugin-pwa's bare
// injectRegister: 'auto' mode) is just `navigator.serviceWorker.register(...)`
// — nothing listens for that handoff, so a tab left open across a deploy
// keeps running old JS that references chunk files the new deploy no
// longer serves. The next interaction (e.g. logging in, which triggers a
// dynamic import or a fresh network call) can then fail to load what it
// needs — a blank screen, "fixed" only by a manual hard reload. Reload
// automatically the moment a new service worker takes over instead.
if ('serviceWorker' in navigator) {
  let reloaded = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (reloaded) return;
    reloaded = true;
    window.location.reload();
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
